import {HttpClient} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {Padron} from '../models';
import {ApiService} from '../../shared';
import {QueryResultApi} from '../../shared';
import {ResponseApiModel} from '../../shared';
import {map} from 'rxjs/operators';
import {AUTH_ROLE_ID} from "../../core/models";
import {LocalStorageService} from "../../core/services";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PadronService extends ApiService<Padron>{
  protected dataKey = 'chacras';
  protected objectKey = 'ChacraPadron';
  protected sendObjectKey = 'padrones';
  protected reciveObjectKey = 'chacras';

  constructor(protected httpClient: HttpClient,
              protected localStorageService: LocalStorageService) {
    super(Padron, httpClient);
  }

  getByGeometry(geometria: string): Observable<QueryResultApi<Padron>> {
    return this.getItems('query', this.dataKey, { geometria });
  }

  getReportePadron(padron: Padron): Observable<string> {
    const resultKey = 'url';
    const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
    return this.httpClient
      .post<ResponseApiModel>(
        this.getUrl('getReportePadron'),
        {
          padronId: padron.padronId,
          departamentoId: padron.departamentoId,
          chacraId: padron.chacraId,
          rolId
        }
      )
      .pipe(
        map((result: any) => {
          return result.getResults[resultKey];
        })
      );
  }

  updatePadron(item: Padron, params = null): Observable<any> {
    return this.update(item, params);
  }

  updatePadronMany(items: Padron[], params = null): Observable<any> {
    return this.updateMany(items, params);
  }

  protected processModifyResult(response: ResponseApiModel[]): any {
    let items: any[] = [];
    if (response.length > 0) {
      let errorMsg = '';
      let success = false;
      for (const r of response){
        if (r.success) {
          success = true;
          if (this.reciveObjectKey in r) {
            items.push(...r[this.reciveObjectKey]);
          }
          else{
            if (this.dataKey in r) {
              items = [...items, ...r[this.dataKey]];
            }
          }
        }else {
          errorMsg += r.error.description + ' / ';
        }
      }
      if (!success && errorMsg !== '') {
        throw throwError(errorMsg);
      }
    } else {
      throw throwError(`Error al procesar los datos recibidos de la petición.`);
    }
    return items;
  }
}
